import React from 'react';
import settings from './settings';
import formatData from './utilities';
import formatData2 from './utilities';
import { point, lineString } from '@turf/helpers';
import mapboxgl from 'mapbox-gl';
import './Map.css';
//import { min } from 'moment';

global.newAssetCoord = null;
global.oldAssetCoord = null;
global.map = null;
global.assets = null;
updateAssets();

function updateAssets() {
  fetch("https://1bp8oybnr6.execute-api.us-east-1.amazonaws.com/dev/")
  .then(response => {
    return response.json();
  })
  .then(data => {
    const keys = Object.keys(data);
    if (!keys.includes("message")) {
      //Set it on the map
      //console.log(data);
      global.assets = data;
      //console.log(global.assets);

      global.assets.features.forEach(function(asset, i){
        asset.properties.id = i;
      });
    } else {
      console.log(data);
    }
  });
};

function flyToAsset(currentFeature) {
  global.map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: settings.INIT_ZOOM
  });
}

function createPopUp(currentFeature) {
  var popUps = document.getElementsByClassName('mapboxgl-popup');
  /** Check if there is already a popup on the map and if so, remove it */
  if (popUps[0]) popUps[0].remove();
  // TODO
  /*const description = Object.entries(currentFeature.properties).reduce(
    (accumulator, featureProperty) => {
      return accumulator.concat(
        `<div><strong>${featureProperty[0]}:</strong> ${
          formatData2(featureProperty[1])
        }</div>`
      )},
    ''
  );*/
  var popup = new mapboxgl.Popup({ closeOnClick: false })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      '<div><strong>ID: </strong>' + currentFeature.properties.deviceId + '</div>' +
      '<div><strong>Speed: </strong>na</div>' +
      '<div><strong>Course: </strong>na</div>' +
      '<div><strong>Temperature: </strong>' + currentFeature.properties.temperature + '</div>' +
      '<div><strong>Humidity: </strong>' + currentFeature.properties.humidity + '</div>' +
      '<div><strong>Light: </strong>' + currentFeature.properties.light + '</div>' +
      '<div><strong>Timeout: </strong>' + currentFeature.properties.timeout + '</div>' +
      '<div><strong>Sample Time: </strong>' + currentFeature.properties.sampleTime + '</div>' +
      '<div><strong>Commit Time: </strong>' + currentFeature.properties.commitTime + '</div>'
    )
    .addTo(global.map);
}

/* This will let you use the .remove() function later on */
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

class Map extends React.Component {
  constructor(){
    super();
    this.state = {
      intervalId: null,
      latestFeature: null,
      lineString: null,
      previousFeature: null
    } 
  }

  componentDidMount(){
    const bucketUrl = `${settings.BASE_URL}/${this.props.match.params.deviceId}/now.txt`
    this.createMap(
      this.mapContainer,
      this.props.mapboxToken,
      bucketUrl
    ) 
  }

  componentWillUnmount(){
    if ( this.state.intervalId ) return clearInterval(this.state.intervalId) 
  }

  /**
   * Add a marker to the map for every store listing.
  **/
  addMarkers() {
    /* For each feature in the GeoJSON object above: */
    global.assets.features.forEach(function(marker) {
      /* Create a div element for the marker. */
      var el = document.createElement('div');
      /* Assign a unique `id` to the marker. */
      el.id = "marker-" + marker.properties.id;
      /* Assign the `marker` class to each marker for styling. */
      el.className = 'marker';
      
      /**
       * Create a marker using the div element
       * defined above and add it to the map.
      **/
      new mapboxgl.Marker(el, { offset: [0, -23] })
        .setLngLat(marker.geometry.coordinates)
        .addTo(this._map);

      /**
       * Listen to the element and when it is clicked, do three things:
       * 1. Fly to the point
       * 2. Close all other popups and display popup for clicked store
       * 3. Highlight listing in sidebar (and remove highlight for all other listings)
      **/
      el.addEventListener('click', function(e){
        /* Fly to the point */
        flyToAsset(marker);
        /* Close all other popups and display popup for clicked store */
        createPopUp(marker);
        /* Highlight listing in sidebar */
        var activeItem = document.getElementsByClassName('active');
        e.stopPropagation();
        if (activeItem[0]) {
          activeItem[0].classList.remove('active');
        }
        var listing = document.getElementById('listing-' + marker.properties.id);
        listing.classList.add('active');
      });
    });
  }

  buildLocationList(data) {
    data.features.forEach(function(asset, i){
      /**
       * Create a shortcut for `asset.properties`,
       * which will be used several times below.
      **/
      var prop = asset.properties;

      /* Add a new listing section to the sidebar. */
      var listings = document.getElementById('listings');
      var listing = listings.appendChild(document.createElement('div'));
      /* Assign a unique `id` to the listing. */
      listing.id = "listing-" + prop.id;
      /* Assign the `item` class to each listing for styling. */
      listing.className = 'item';

      /* Add the link to the individual listing created above. */
      var link = listing.appendChild(document.createElement('a'));
      link.href = '#';
      link.className = 'title';
      link.id = "link-" + prop.id;
      link.innerHTML = "<strong>" + prop.deviceId + "</strong>";

      /* Add details to the individual listing. */
      var details = listing.appendChild(document.createElement('div'));
      details.innerHTML = asset.geometry.coordinates[0] + ", " + asset.geometry.coordinates[1];
      if (prop.phone) {
        details.innerHTML += ' · ' + prop.deviceId;
      }

      /**
       * Listen to the element and when it is clicked, do four things:
       * 1. Update the `currentFeature` to the store associated with the clicked link
       * 2. Fly to the point
       * 3. Close all other popups and display popup for clicked store
       * 4. Highlight listing in sidebar (and remove highlight for all other listings)
      **/
      link.addEventListener('click', function(e){
        for (var i=0; i < data.features.length; i++) {
          if (this.id === "link-" + data.features[i].properties.id) {
            var clickedListing = data.features[i];
            console.log(clickedListing)
            flyToAsset(clickedListing);
            createPopUp(clickedListing);
          }
        }
        var activeItem = document.getElementsByClassName('active');
        if (activeItem[0]) {
          activeItem[0].classList.remove('active');
        }
        this.parentNode.classList.add('active');
      });
    });
  }

  // CREATE MAP
  createMap(mapContainer, mapboxToken, s3BucketUrl) {
    mapboxgl.accessToken = mapboxToken

    // Load Mapbox
    const map = new mapboxgl.Map({
      container: mapContainer,
      style: settings.MAPBOX_STYLE,
      center: [ -100, 40],  //USA
      zoom: 2.5
    });
    global.map = this._map = map;

    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

    map.on('load', () => {
      /* Add the data to your map as a layer */
      map.addLayer({
        "id": "locations",
        "type": "symbol",
        /* Add a GeoJSON source containing place coordinates and information. */
        "source": {
          "type": "geojson",
          "data": global.assets
        },
        "layout": {
          "icon-image": "marker-11",
          "icon-allow-overlap": true,
        }
      });
      this.buildLocationList(global.assets);
      this.beginFetchingData(s3BucketUrl)
    });

    /*map.on('click', function(e) {
      //Determine if a feature in the "locations" layer exists at that point.
      var features = this._map.queryRenderedFeatures(e.point, {
        layers: ['locations']
      });
      
      // If yes, then:
      if (features.length) {
        var clickedPoint = features[0];
        
        //Fly to the point
        flyToAsset(clickedPoint);
        
        // Close all other popups and display popup for clicked store
        createPopUp(clickedPoint);
        
        // Highlight listing in sidebar (and remove highlight for all other listings)
        var activeItem = document.getElementsByClassName('active');
        if (activeItem[0]) {
          activeItem[0].classList.remove('active');
        }
        var listing = document.getElementById('listing-' + clickedPoint.properties.id);
        listing.classList.add('active');
      }
    });*/
  }

  // Process S3 Content
  processGeojson = async feature => {
    if ( this.state.lineString === null ) {
      if ( this.state.latestFeature === null ) {
        // first fetch. just need to create a point and add it to the map
        return this.setState({
          latestFeature: point(feature.geometry.coordinates, feature.properties)
        }, this.drawGeojson)
      } else {
        // second fetch need to create our first line feature
        const lineStringFeature = lineString([this.state.latestFeature.geometry.coordinates, feature.geometry.coordinates])
        return this.setState({
          latestFeature: point(feature.geometry.coordinates, feature.properties),
          lineString: lineStringFeature
        }, this.drawGeojson)
      }
    }
    // we have a line string. we need to continue building on it.
    return this.setState({
      latestFeature: point(feature.geometry.coordinates, feature.properties),
      lineString: lineString([feature.geometry.coordinates, ...this.state.lineString.geometry.coordinates])
    }, this.drawGeojson)
  }

  drawGeojson = () => {
    if ( this.state.lineString === null ) {
      this._map.addSource('tracker', { type: 'geojson', data: this.state.lineString });
      this._map.addSource('latest-location', { type: 'geojson', data: this.state.latestFeature })
      
      // style for line between points
      this._map.addLayer({
        "id": "tracker",
        "type": "line",
        "source": "tracker",
        "layout": {
          "line-join": "round",
          "line-cap": "round"
        },
        "paint": {
          'line-color': 'gray',
          'line-width': 2,
          'line-dasharray': [2, 1],
        }
      });
      // style for points between lines
      this._map.addLayer({
        "id": "prev-locations",
        "type": "circle",
        "source": "tracker",
        "paint": {
          "circle-color": 'gray',
          "circle-radius": 3
        }
      })
      // style for latest location
      this._map.addLayer({
        "id": "latest-location",
        "type": "symbol",
        "source": "latest-location",
        "layout": {
          "icon-image": "circle-15"
        }
      })

      // Click on Asset
      this._map.on('click', 'latest-location', event => {
        const description = Object.entries(event.features[0].properties).reduce(
          (accumulator, featureProperty) => {
            return accumulator.concat(
              `<div><strong>${featureProperty[0]}:</strong> ${
                formatData(featureProperty)
              }</div>`
            )},
          ''
        );

        // show the tooltip exactly where you clicked
        new mapboxgl.Popup()
          .setLngLat([event.lngLat.lng, event.lngLat.lat])
          .setHTML(
            `<div className="mapbox-view-tooltip-wrapper">${description}</div>`
          )
          .addTo(this._map);
      });
      
    } else {
      this._map.getSource('tracker').setData(this.state.lineString)
      this._map.getSource('latest-location').setData(this.state.latestFeature)
      global.newAssetCoord = this.state.latestFeature.geometry.coordinates
      
      //console.log(global.newAssetCoord)
      //console.log(global.oldAssetCoord)
      if ((global.oldAssetCoord == null) || ((global.oldAssetCoord[0]!==global.newAssetCoord[0]) && (global.oldAssetCoord[1]!==global.newAssetCoord[1]))){
        if (settings.ENABLE_3D) {
          this._map.flyTo({
            center: this.state.latestFeature.geometry.coordinates,
            zoom: settings.INIT_ZOOM,
            pitch: settings.INIT_PITCH,
            bearing: 0 })
        } else {
          this._map.flyTo({
            center: this.state.latestFeature.geometry.coordinates,
            zoom: settings.INIT_ZOOM})
        }
        global.oldAssetCoord = this.state.latestFeature.geometry.coordinates
      }
    }
  }

  // Looping function for processing S3 values every X Seconds
  beginFetchingData = url => {
    const intervalId = setInterval(async () => {
      const feature = await fetch(url).then( resp => resp.json() ) 
      this.setState({ intervalId })
      console.log(feature)
      return this.processGeojson(feature)
    }, settings.POLL_INTERVAL)
  }

  render(){
    return (
      <div
        id='map-container'
        ref={el => (this.mapContainer = el)}
      />
    );
  }

}

export default Map;
